import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useRevenueByFoodCourt } from '@hooks/dashboard/useKapi';

const RevenueByFoodCourt: React.FC = () => {
  const { data, isLoading } = useRevenueByFoodCourt();

  if (isLoading) return <div className="chart-loading">Loading...</div>;

  const chartData = data && data.length > 0
    ? data.slice(0, 8).map((d, i) => ({
        name: d.foodCourtName || `Food Court ${i + 1}`,
        revenue: Math.round(d.revenue),
        orders: d.orderCount,
      }))
    : [{ name: 'No Data', revenue: 0, orders: 0 }];

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
        <defs>
          <linearGradient id="revenueGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#3B82F6" stopOpacity={0.8} />
            <stop offset="100%" stopColor="#6366F1" stopOpacity={0.9} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" horizontal={false} />
        <XAxis type="number" tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} tickFormatter={(v) => `₹${v}`} />
        <YAxis type="category" dataKey="name" tick={{ fontSize: 10, fill: '#374151' }} axisLine={false} tickLine={false} width={100} />
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12 }}
          formatter={(value: number) => [`₹${value.toLocaleString()}`, 'Revenue']}
        />
        <Bar dataKey="revenue" fill="url(#revenueGrad)" radius={[0, 6, 6, 0]} maxBarSize={24} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RevenueByFoodCourt;
